module.exports = __webpack_public_path__ + "static/img/logo_txt.40a2f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_txt.png
// module id = zC8j
// module chunks = 3